import script from "./PromoCommonInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromoCommonInfo.vue?vue&type=script&lang=ts&setup=true"

import "./PromoCommonInfo.vue?vue&type=style&index=0&id=26371474&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26371474"]])

export default __exports__